var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leco-content"},[_c('div',{staticClass:"redirect-msg"},[_vm._v("録画ページにリダイレクトします。")]),_c('loading',{attrs:{"active":_vm.isPostLoading},on:{"update:active":function($event){_vm.isPostLoading=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }